const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$domSliderPrev: $('.js-slider-bottom__arr-prev'),
	$domSliderNext: $('.js-slider-bottom__arr-next'),
	$domSliderProducts: $('.js-product-slider'),
	$domSliderProductsPrev: $('.js-slider-product__arr-prev'),
	$domSliderProductsNext: $('.js-slider-product__arr-next'),
	$domSliderProductsDots: $('.js-slider-product-dots'),
	$domSliderTestimonial: $('.js-testimonial-slider__boxes'),
	$domSliderTestimonialNext: $('.js-testimonial-slider__arr-next'),
	$domSliderTestimonialPrev: $('.js-testimonial-slider__arr-prev'),
	$domSingleProductSlider: $('.js-single-product__slider'),
	$domSingleProductSliderSmall: $('.js-single-product__slider-small'),
	$domSingleProductSliderSmallPrev: $('.js-single-product__slider-small-arr-prev'),
	$domSingleProductSliderSmallNext: $('.js-single-product__slider-small-arr-next'),
	$domRelatedProductsSlider: $('.js-single-product__related-sliders'),

	/** @description Initialize. */
	init: function() {
		this.initSlider();
		this.initSliderProducts();
		this.initSliderProductsSecond();
		this.initSliderTestimonial();
		this.initSingleProductSlider();
		this.initSingleProductSliderSmall();
		this.initRelatedProductsSlider();
	},

	/** @description Set and run slider. */
	initSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: false,
			autoplay: false,
			arrows: true,
			prevArrow: $('.js-slider-bottom__arr-prev'),
			nextArrow: $('.js-slider-bottom__arr-next'),
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
						variableWidth: false
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						variableWidth: false
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 1,
						variableWidth: false
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSlider, config);
	},

	initSliderProducts: function() {
		$('.js-product-slider').each(function(i, el) {
			// create object with base config options
			const baseConfig = new SliderBaseConfig();
			// set extra config options
			const extraConfig = {
				infinite: true,
				autoplay: false,
				arrows: true,
				prevArrow: $(el).next().find('.js-slider-product__arr-prev'),
				nextArrow: $(el).next().find('.js-slider-product__arr-next'),
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				// appendDots: Sliders.$domSliderProductsDots,
				responsive: [
					{
						breakpoint: 1380,
						settings: {
							slidesToShow: 1,
							variableWidth: false
						}
					},
				]
			};
			// merge two config objects
			const config = {
				...baseConfig,
				...extraConfig
			};
			// run slider
			/* this.runSlider(this.$domSliderProducts, config); */
			Sliders.runSlider($(el), config);
		});
	},

	initSliderProductsSecond: function() {
		$('.js-product-slider-new.ajax-slider').each(function(i, el) {
			// create object with base config options
			const baseConfig = new SliderBaseConfig();
			// set extra config options
			const extraConfig = {
				infinite: true,
				autoplay: false,
				arrows: true,
				prevArrow: $(el).next().find('.js-slider-product__arr-prev'),
				nextArrow: $(el).next().find('.js-slider-product__arr-next'),
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				// appendDots: Sliders.$domSliderProductsDots,
				responsive: [
					{
						breakpoint: 1380,
						settings: {
							slidesToShow: 1,
							variableWidth: false
						}
					},
				]
			};
			// merge two config objects
			const config = {
				...baseConfig,
				...extraConfig
			};
			// run slider
			/* this.runSlider(this.$domSliderProducts, config); */
			Sliders.runSlider($(el), config);
		});
	},

	initSliderTestimonial: function() {
		Sliders.$domSliderTestimonial.each(function(i, el) {
			// create object with base config options
			const baseConfig = new SliderBaseConfig();
			// set extra config options
			const extraConfig = {
				infinite: false,
				autoplay: false,
				variableWidth: true,
				arrows: true,
				prevArrow: Sliders.$domSliderTestimonialPrev,
				nextArrow: Sliders.$domSliderTestimonialNext,
				slidesToShow: 2,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 2,
							variableWidth: false
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							variableWidth: false
						}
					},
				]
			};
			// merge two config objects
			const config = {
				...baseConfig,
				...extraConfig
			};
			// run slider
			/* this.runSlider(this.$domSliderProducts, config); */
			Sliders.runSlider($(el), config);
		});
	},

	initSingleProductSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: false,
			autoplay: false,
			arrows: false,
			dots: false,
			fade: true,
			touchThreshold: 200,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.js-single-product__slider-small',
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSingleProductSlider, config);
	},

	initSingleProductSliderSmall: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: false,
			autoplay: false,
			arrows: true,
			prevArrow: Sliders.$domSingleProductSliderSmallPrev,
			nextArrow: Sliders.$domSingleProductSliderSmallNext,
			dots: false,
			touchThreshold: 200,
			focusOnSelect: true,
			vertical: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			asNavFor: '.js-single-product__slider',
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 3,
						vertical: false,
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSingleProductSliderSmall, config);
	},

	initRelatedProductsSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: false,
			// prevArrow: $('.js-slider-bottom__arr-prev'),
			// nextArrow: $('.js-slider-bottom__arr-next'),
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 400,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domRelatedProductsSlider, config);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
			if ($(el).hasClass('ajax-slider')) {
				$(el).removeClass('ajax-slider');
			}
		});
	}
};

export default Sliders;
